import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import DashboardLayout from '../Components/DashboardLayout/DashboardLayout'
import menuConfig from '../../config/MenuConfig';

const VendorRouter = () => {
  return (
    <DashboardLayout>
      <Routes>
        {menuConfig.filter(item => item.category === "Vendor").map(({ path, component: Component }) => (
          <Route
            key={path}
            path={path.replace("/vendor/", "")} // React Router expects relative path
            element={<Component />}
          />
        ))}

        {/* Fallback route if no match */}
        <Route path="*" element={<Navigate to="/vendor" />} />
      </Routes>
    </DashboardLayout>

  );
};

export default VendorRouter
